module.exports = __webpack_public_path__ + "img/Gift_Guide-lifestyle.8ee5979.jpg";